<ng-template #iconRef>
	<svg fill="none" height="70" viewBox="0 0 70 70" width="70" xmlns="http://www.w3.org/2000/svg">
		<circle cx="35" cy="35" fill="#F08922" fill-opacity="0.2" r="35"/>
		<path
			d="M35 55C23.9543 55 15 46.0457 15 35C15 23.9543 23.9543 15 35 15C46.0457 15 55 23.9543 55 35C54.9879 46.0407 46.0407 54.9879 35 55ZM33 41V45H37V41H33ZM33 25V37H37V25H33Z"
			fill="#F08922"/>
	</svg>
</ng-template>
<app-kamona-dialog [icon]="iconRef">
	<div class="device-registration-modal">
		<div class="title">
			Device Registration
		</div>
		<div *ngIf="false" class="description">
			You have registered <span class="text-bolder">3 out of 5 Devices</span>
		</div>
		<div class="description-container">
			<div class="des">
				Your login was successful
				but you need to register this device.
			</div>
		</div>
		<div class="footer-content">
			<div class="m-t-25">
				<div class="button-size-max-320" nz-row nzJustify="center">
					<div class="kamona-button-session" nz-col nzSpan="24">
						<app-kamona-custom-button
							(submitForm)="registerDevice()"
							[isBlock]="true" text="Register Device">
						</app-kamona-custom-button>
					</div>
				</div>
			</div>
			<div class="m-t-33">
				<div (click)="dismissModal()" class="mobile-modal-dismiss-btn">
					Dismiss
				</div>
			</div>
		</div>
	</div>
</app-kamona-dialog>

